import { goToPayPal } from "@/lib/paypal";
import { ArrowRight } from "lucide-react";

/**
 * Reusable PayPal Hosted Redirect button.
 * Records purchase intent then redirects the current tab. Never opens new tab.
 */
export default function PayPalButton({
  plan_id,
  plan_name,
  price,
  label = "Continue with PayPal",
  variant = "primary",
  className = "",
  testId,
}) {
  const cls =
    variant === "primary"
      ? "btn-primary"
      : "btn-ghost";
  const onClick = () => goToPayPal({ plan_id, plan_name, price });
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${cls} ${className}`}
      data-testid={testId || `paypal-btn-${plan_id}`}
    >
      {label}
      <ArrowRight className="h-4 w-4" />
    </button>
  );
}
